import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "./locales/es.json";
import en from "./locales/en.json";
import ca from "./locales/ca.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";
import ptBr from "./locales/pt-br.json";

const VALID_LOCALES = ["es", "en", "ca", "fr", "it", "de", "nl", "pt-br"];

function getStoredLang(): string {
  const raw = localStorage.getItem("rms-locale");
  if (!raw) return "es";
  if (VALID_LOCALES.includes(raw)) return raw;
  // Handle legacy zustand persist format
  if (raw.startsWith("{")) {
    try {
      const parsed = JSON.parse(raw);
      const code = parsed?.state?.locale ?? parsed?.locale;
      if (code && VALID_LOCALES.includes(code)) {
        localStorage.setItem("rms-locale", code);
        return code;
      }
    } catch { /* ignore */ }
  }
  localStorage.removeItem("rms-locale");
  return "es";
}

const storedLang = getStoredLang();

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    ca: { translation: ca },
    fr: { translation: fr },
    it: { translation: it },
    de: { translation: de },
    nl: { translation: nl },
    "pt-br": { translation: ptBr },
  },
  lng: storedLang,
  fallbackLng: "es",
  interpolation: { escapeValue: false },
});

export default i18n;
